/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import upperCase from 'lodash.uppercase';
import startCase from 'lodash.startcase';
import capitalize from 'lodash.capitalize';

import topimg from '../assets/images/company5.png';
import { toggleProfile, toggleMode, toggleMenu, toggleFullscreen, signOut } from '../actions/user';
import { setConnection } from '../actions/general';
import {
	newChatMesage,
	setActiveUsers,
	setChatMessageRead,
	setRoomId,
	setChatId,
	setUnreadChats,
	setGroupedChats,
	setUnread,
} from '../actions/chat';
import SearchPatient from './SearchPatient';
import { staffname, parseAvatar, request, patientname } from '../services/utilities';
import SSRStorage from '../services/storage';
import { TOKEN_COOKIE, USER_RECORD, CK_ENCOUNTER, SIDE_PANEL, BROWSER_SESSION } from '../services/constants';
import { disconnectSocket, emitChat, disconnectChatSocket } from '../services/socket';
import { messageService } from '../services/message';
import SoundeComp from './SoundeComp';
import VideoTutorialsPopover from './VideoTutorials/VideoTutorialsPopover';
import { notifyCustom } from '../services/notify';
import moment from 'moment';
import { startBlock, stopBlock } from '../actions/redux-block';
import { hasViewSearchMenuPermission } from '../permission-utils/settings';

const storage = new SSRStorage();

const notificationStyle = {
	border: '5px solid #1e62eb',
	background: 'linear-gradient(270deg,rgba(104, 174, 255, 0.8) 0%,rgba(211, 231, 253, 0.9) 100%)',
	color: '#1e62eb',
	width: '440px',
	marginLeft: '-129px',
	padding: '10px',
	borderRadius: '8px',
	boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
	fontSize: '15px',
};

const partographNotificationStyle = {
	border: '4px solid #d9534f',
	background: 'linear-gradient(270deg,rgba(255, 209, 209, 0.9) 0%,rgba(255, 241, 241, 0.95) 100%)',
	color: '#8b1d1d',
	width: '440px',
	marginLeft: '-129px',
	padding: '10px',
	borderRadius: '8px',
	boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
	fontSize: '15px',
};

class TopBar extends Component {
	state = {
		hover_settings: false,
		hover_unread: false,
		hover_notifications: false,
		focus: false,
		style: { display: 'none' },
		count: 0,
		profile_image: null,
		triggerSound: 0,
		chatType: '',
		notifications: [], // Store all notifications
		clearingNotifications: false,
	};

	fetchPendingNotifications = async () => {
		try {
			this.props.startBlock();
			const url = 'patient/admissions/get-notifications';
			const response = await request(url, 'GET', true);

			if (response.length) {
				const newNotifications = response.map(notification => {
					const { patient, start_discharge_date, room, start_discharge_by, date_discharged, dischargedBy, id } = notification.admission;

					if (date_discharged) {
						return {
							id,
							type: 'discharge-finished',
							timestamp: new Date(),
							data: {
								patient,
								date_discharged,
								dischargedBy,
								start_discharge_by,
								room,
							},
							notificationId: id,
						};
					} else {
						return {
							id,
							type: 'discharge-started',
							timestamp: new Date(),
							data: {
								patient,
								start_discharge_date,
								start_discharge_by,
								room,
							},
							notificationId: id,
						};
					}
				});

				// Add to notifications container but NO TOAST for API-fetched notifications
				this.setState(prevState => ({
					notifications: [...prevState.notifications, ...newNotifications],
					count: prevState.count + newNotifications.length,
				}));
			}
		} catch (error) {
			console.log('Error fetching pending notifications:', error);
		} finally {
			this.props.stopBlock();
		}
	};

	fetchPendingLabourNotifications = async () => {
		try {
			const url = 'labour-managements/notifications/pending';
			const response = await request(url, 'GET', true);

			if (response.length) {
				const newNotifications = response.map(notification => {
					const payload = notification.payload || {};
					return {
						id: notification.id,
						type: 'partograph-alert',
						timestamp: notification.createdAt || new Date(),
						data: {
							status: payload.status || 'alert',
							message: payload.message,
							patient_name: payload.patient_name,
							labour_id: payload.labour_id,
							event_time: payload?.chart?.event_time,
						},
						notificationApi: 'labour',
						notificationId: notification.id,
					};
				});

				this.setState(prevState => ({
					notifications: [...prevState.notifications, ...newNotifications],
					count: prevState.count + newNotifications.length,
				}));
			}
		} catch (error) {
			console.log('Error fetching pending labour notifications:', error);
		}
	};

	addNotification = notification => {
		this.setState(prevState => ({
			notifications: [notification, ...prevState.notifications],
			count: prevState.count + 1,
		}));
	};

	removeNotification = async (notificationId, apiNotificationId = null, notificationApi = 'admission') => {
		if (apiNotificationId) {
			try {
				const closeUrl =
					notificationApi === 'labour'
						? `labour-managements/notifications/close/${notificationId}`
						: `patient/admissions/close-notification/${notificationId}`;
				await request(closeUrl, 'PUT', true);
				const remainingNotifications = this.state.notifications.filter(n => n.id !== +notificationId);
				this.setState({
					notifications: remainingNotifications,
					count: remainingNotifications.length,
				});
			} catch (error) {
				console.log(error);
			}
		}

		this.setState(prevState => ({
			notifications: prevState.notifications.filter(n => n.id !== notificationId),
			count: Math.max(0, prevState.count - 1),
		}));
	};

	clearAllNotifications = async () => {
		try {
			this.setState({ clearingNotifications: true });
			const admissionIds = this.state.notifications
				.filter(n => n.notificationApi !== 'labour')
				.map(n => +n.id)
				.filter(Boolean);
			const labourIds = this.state.notifications
				.filter(n => n.notificationApi === 'labour')
				.map(n => +n.id)
				.filter(Boolean);

			if (admissionIds.length) {
				const admissionUrl = `patient/admissions/close-notifications?ids=${admissionIds.join('-')}`;
				await request(admissionUrl, 'PUT', true);
			}

			if (labourIds.length) {
				const labourUrl = `labour-managements/notifications/close-all?ids=${labourIds.join('-')}`;
				await request(labourUrl, 'PUT', true);
			}

			this.setState({
				notifications: [],
				count: 0,
			});
		} catch (error) {
			console.log('Error clearing all notifications:', error);
		} finally {
			this.setState({ clearingNotifications: false });
		}
	};

	renderNotification = notification => {
		const { type, data, timestamp, id, notificationId, notificationApi } = notification;

		switch (type) {
			case 'discharge-finished':
				return (
					<div key={`${notificationId}-discharge-finished`} className="notification-item">
						<div className="notification-header">
							<h6 className="text-secondary mb-1">Discharge Finished</h6>
							<button className="btn btn-sm btn-link p-0" onClick={() => this.removeNotification(id, notificationId)}>
								<i className="os-icon os-icon-close" />
							</button>
						</div>
						<p className="text-secondary m-0">
							Patient: <strong>{patientname(data.patient, true)}</strong>
						</p>
						<p className="text-secondary m-0">
							Discharged on: <strong>{data.date_discharged}</strong>
						</p>
						{data.dischargedBy ? (
							<p className="text-secondary m-0">
								Discharge by: <strong>{staffname(data.dischargedBy)}</strong>
							</p>
						) : (
							<p className="text-secondary m-0">
								Discharged by: <strong>{data.start_discharge_by}</strong>
							</p>
						)}
						{data.room && (
							<p className="text-secondary m-0">
								Room: <strong>{startCase(data.room.name)}</strong>
							</p>
						)}
						<small className="text-muted">{moment(timestamp).fromNow()}</small>
					</div>
				);

			case 'discharge-started':
				return (
					<div key={`${notificationId}-discharge-started`} className="notification-item">
						<div className="notification-header">
							<h6 className="text-secondary mb-1">Discharge Started</h6>
							<button className="btn btn-sm btn-link p-0" onClick={() => this.removeNotification(id, notificationId)}>
								<i className="os-icon os-icon-close" />
							</button>
						</div>
						<p className="text-secondary m-0">
							Patient: <strong>{patientname(data.patient, true)}</strong>
						</p>
						<p className="text-secondary m-0">
							Discharged on: <strong>{data.start_discharge_date}</strong>
						</p>
						<p className="text-secondary m-0">
							Discharged by: <strong>{data.start_discharge_by}</strong>
						</p>
						{data.room && (
							<p className="text-secondary m-0">
								Room: <strong>{startCase(data.room.name)}</strong>
							</p>
						)}
						<small className="text-muted">{moment(timestamp).fromNow()}</small>
					</div>
				);

			case 'lab-result':
				return (
					<div key={id} className="notification-item lab-result">
						<div className="notification-header">
							<h6 className="text-white mb-1">Lab result ready for {data.labTest}</h6>
							<button className="btn btn-sm btn-link p-0 text-white" onClick={() => this.removeNotification(id)}>
								<i className="os-icon os-icon-close" />
							</button>
						</div>
						<p className="text-white m-0">{patientname(data.patient, true)}</p>
						<p className="text-white m-0">Duration: {data.duration}</p>
						<small className="text-white-50">{moment(timestamp).fromNow()}</small>
					</div>
				);

			case 'lab-result-approved':
				return (
					<div key={id} className="notification-item lab-result-approved">
						<div className="notification-header">
							<h6 className="text-white mb-1">Lab result approved for {data.labTest}</h6>
							<button className="btn btn-sm btn-link p-0 text-white" onClick={() => this.removeNotification(id)}>
								<i className="os-icon os-icon-close" />
							</button>
						</div>
						<p className="text-white m-0">{patientname(data.patient, true)}</p>
						<p className="text-white m-0">Duration: {data.duration}</p>
						<small className="text-white-50">{moment(timestamp).fromNow()}</small>
					</div>
				);

			case 'chat-message':
				return (
					<div key={id} className="notification-item chat-message">
						<div className="notification-header">
							<h6 className="mb-1">{data.from} sent you a message</h6>
							<button className="btn btn-sm btn-link p-0" onClick={() => this.removeNotification(id)}>
								<i className="os-icon os-icon-close" />
							</button>
						</div>
						<p className="m-0">{data.message}</p>
						<small className="text-muted">{moment(timestamp).fromNow()}</small>
					</div>
				);

			case 'patient-media-message':
				return (
					<div key={id} className="notification-item">
						<div className="notification-header">
							<h6 className="text-secondary mb-1">New Patient Message</h6>
							<button className="btn btn-sm btn-link p-0" onClick={() => this.removeNotification(id)}>
								<i className="os-icon os-icon-close" />
							</button>
						</div>
						<p className="text-secondary m-0">Time Stamp: {moment(data.timestamp).format('YYYY-MM-DD HH:mm')}</p>
						<small className="text-muted">{moment(timestamp).fromNow()}</small>
					</div>
				);

			case 'partograph-alert':
				return (
					<div key={id} className="notification-item" style={{ borderLeft: '4px solid #d9534f' }}>
						<div className="notification-header">
							<h6 className="text-danger mb-1">Partograph {capitalize(data.status || 'alert')}</h6>
							<button className="btn btn-sm btn-link p-0" onClick={() => this.removeNotification(id, notificationId, notificationApi)}>
								<i className="os-icon os-icon-close" />
							</button>
						</div>
						<p className="text-secondary m-0">
							Patient: <strong>{data.patient_name || '--'}</strong>
						</p>
						<p className="text-secondary m-0">{data.message || 'Partograph threshold crossed'}</p>
						{data.labour_id ? (
							<p className="text-secondary m-0">
								Labour ID: <strong>{data.labour_id}</strong>
							</p>
						) : null}
						<small className="text-muted">{moment(timestamp).fromNow()}</small>
					</div>
				);

			default:
				return null;
		}
	};

	doUpdateChats = newChat => {
		const { unreadChats: chats, unread, setUnread, setUnreadChats } = this.props;
		const temp = [...chats];

		const index = temp.findIndex(chat => chat.id === newChat.sender_id);
		if (index > -1) {
			temp[index].message.unshift(newChat);
		} else {
			const newChats = {
				profile_pic: null,
				id: newChat.sender_id,
				first_name: newChat.sender_first_name,
				last_name: newChat.sender_last_name,
				alias: newChat.alias,
				message: [newChat],
			};
			temp.push(newChats);
		}

		setUnreadChats(temp);
		setUnread(unread + 1);
	};

	componentDidMount() {
		const image = localStorage.getItem('STAFFIMAGE');
		this.setState({ profile_image: image });

		this.fetchPendingNotifications();
		this.fetchPendingLabourNotifications();

		// chat socket subscription
		this.subscription = messageService.getMessage().subscribe(message => {
			const { type, data } = message.text;

			if (type === 'new-chat-message') {
				const { chatId, roomId, groupedChats, setGroupedChats } = this.props;

				if (data.sender_id !== this.props.profile.details.id) {
					if (data.sender_id !== chatId) {
						this.doUpdateChats(data);
						this.setState({ chatType: 'chat' });
						this.handleTriggerSound(data.sender_first_name, data.body);
					}
				}

				if (data.recipient_id === chatId || data.sender_id === chatId) {
					if (data.room_id && data.room_id !== roomId) {
						return;
					}
					const date = new Date().toDateString();
					data.createdAt = new Date();

					const temp = [...groupedChats];
					const index = temp.findIndex(group => group.date === date);
					if (index === -1) {
						temp.push({
							date,
							chats: [data],
						});
					} else {
						temp[index].chats.push(data);
					}
					setGroupedChats(temp);
				}
			}

			if (type === 'active_users') {
				this.props.setActiveUsers(data.users);
			}

			if (type === 'new-support-message') {
				if (data.sender_id !== this.props.profile.details.id) {
					this.setState({ chatType: 'support' });
					this.handleTriggerSound(data.sender_first_name, data.body);
				}
			}

			if (type === 'new-support-reply-message') {
				if (data.sender_id !== this.props.profile.details.id) {
					this.setState({ chatType: 'support' });
					this.handleTriggerSound(data.sender_first_name, data.body);
				}
			}

			if (type === 'lab-result') {
				console.log('lab-result', data);
				const requestTime = moment(data.requestTime);
				const approveTime = moment(data.approveTime);
				const duration = moment.duration(approveTime.diff(requestTime));

				let output;
				if (duration.days() > 0) {
					output = `${duration.days()}days ${duration.hours()}hours ${duration.minutes()}minutes`;
				} else if (duration.hours() > 0) {
					output = `${duration.hours()}hours ${duration.minutes()}minutes`;
				} else {
					output = `${duration.minutes()}minutes`;
				}

				notifyCustom(
					<>
						<h6 className="text-white">Lab result ready for {data.request.item.labTest.name}</h6>
						<p>{patientname(data.request.patient, true)}</p>
						<p>Duration: {output}</p>
					</>,
					{
						position: 'top-right',
						autoClose: false,
						style: {
							wordBreak: 'break-word',
							background: '#1e62eb',
							color: '#fff',
							width: '440px',
							marginLeft: '-129px',
						},
						type: 'success',
					}
				);

				const notification = {
					id: `lab-result-${Date.now()}`,
					type: 'lab-result',
					timestamp: new Date(),
					data: {
						labTest: data.request.item.labTest.name,
						patient: data.request.patient,
						duration: output,
					},
				};

				this.addNotification(notification);
			}

			if (type === 'lab-result-approved') {
				console.log('lab-result-approved', data);
				const requestTime = moment(data.requestTime);
				const approveTime = moment(data.approveTime);
				const duration = moment.duration(approveTime.diff(requestTime));

				let output;
				if (duration.days() > 0) {
					output = `${duration.days()}days ${duration.hours()}hours ${duration.minutes()}minutes`;
				} else if (duration.hours() > 0) {
					output = `${duration.hours()}hours ${duration.minutes()}minutes`;
				} else {
					output = `${duration.minutes()}minutes`;
				}

				notifyCustom(
					<>
						<h6 className="text-white">Lab result approved for {data.request.item.labTest.name}</h6>
						<p>{patientname(data.request.patient, true)}</p>
						<p>Duration: {output}</p>
					</>,
					{
						position: 'top-right',
						autoClose: 5000,
						style: {
							wordBreak: 'break-word',
							background: '#8b5cf6',
							color: '#fff',
							width: '440px',
							marginLeft: '-129px',
						},
						type: 'success',
					}
				);

				const notification = {
					id: `lab-result-approved-${Date.now()}`,
					type: 'lab-result-approved',
					timestamp: new Date(),
					data: {
						labTest: data.request.item.labTest.name,
						patient: data.request.patient,
						duration: output,
					},
				};

				this.addNotification(notification);
			}

			if (type === 'discharge-patient') {
				const { id, patient, start_discharge_date, room, start_discharge_by, date_discharged, dischargedBy } = data.admission;

				const handleClose = async () => {
					try {
						const url = `patient/admissions/close-notification/${id}`;
						await request(url, 'PUT', true);
					} catch (error) {
						console.log(error);
					}
				};

				clearTimeout(this.dischargeTimeout);
				this.dischargeTimeout = setTimeout(() => {
					// Show toast for real-time discharge notification with 5-second timer
					if (date_discharged) {
						notifyCustom(
							<>
								<h6 className="text-secondary">Discharge Finished</h6>
								<p className="text-secondary m-0">
									Patient: <strong>{patientname(patient, true)}</strong>
								</p>
								<p className="text-secondary m-0">
									Discharged on: <strong>{date_discharged}</strong>
								</p>
								{dischargedBy ? (
									<p className="text-secondary m-0">
										Discharge by: <strong>{staffname(dischargedBy)}</strong>
									</p>
								) : (
									<p className="text-secondary m-0">
										Discharged by: <strong>{start_discharge_by}</strong>
									</p>
								)}
								{room ? (
									<p className="text-secondary m-0">
										Room: <strong>{startCase(room.name)}</strong>{' '}
									</p>
								) : null}
							</>,
							{
								position: 'top-right',
								autoClose: 5000, // 5 seconds auto-close
								style: notificationStyle,
								type: 'default',
								onClose: handleClose,
							}
						);
					} else {
						notifyCustom(
							<>
								<h6 className="text-secondary">Discharge Started</h6>
								<p className="text-secondary m-0">Patient: {patientname(patient, true)}</p>
								<p className="text-secondary m-0">Discharged on: {start_discharge_date}</p>
								<p className="text-secondary m-0">Discharged by: {start_discharge_by}</p>
								{room ? <p className="text-secondary m-0">Room: {startCase(room.name)}</p> : null}
							</>,
							{
								position: 'top-right',
								autoClose: 5000, // 5 seconds auto-close
								style: notificationStyle,
								type: 'default',
								onClose: handleClose,
							}
						);
					}

					// Also add to notifications container (persists until manually cleared)
					const notification = {
						id,
						type: date_discharged ? 'discharge-finished' : 'discharge-started',
						timestamp: new Date(),
						data: {
							patient,
							start_discharge_date,
							start_discharge_by,
							date_discharged,
							dischargedBy,
							room,
						},
						notificationId: id,
					};

					this.addNotification(notification);
				}, 1000);
			}

			if (type === 'message-read') {
				const { count, messages } = data;
				const { setUnread, setUnreadChats } = this.props;
				setUnread(count);
				setUnreadChats(messages);
			}

			if (type === 'private-media-message') {
				const { timestamp } = data;

				clearTimeout(this.dischargeTimeout);
				this.dischargeTimeout = setTimeout(() => {
					// Show toast for real-time patient media message
					notifyCustom(
						<>
							<h6 className="text-secondary">New Patient Message</h6>
							<p className="text-secondary m-0">Time Stamp: {moment(timestamp).format('YYYY-MM-DD HH:mm')}</p>
						</>,
						{
							position: 'bottom-right',
							autoClose: true,
							style: notificationStyle,
							type: 'default',
						}
					);

					// Also add to notifications container
					const notification = {
						id: `patient-media-${Date.now()}`,
						type: 'patient-media-message',
						timestamp: new Date(),
						data: { timestamp },
					};

					this.addNotification(notification);
				}, 1000);
			}

			if (type === 'partograph-alert') {
				const payload = data?.notification?.payload || {};
				const id = data?.notification?.id;
				if (!id) {
					return;
				}

				notifyCustom(
					<>
						<h6 className="text-danger">Partograph {capitalize(payload.status || 'alert')}</h6>
						<p className="text-secondary m-0">Patient: {payload.patient_name || '--'}</p>
						<p className="text-secondary m-0">{payload.message || 'Partograph threshold crossed'}</p>
					</>,
					{
						position: 'top-right',
						autoClose: 8000,
						style: partographNotificationStyle,
						type: 'default',
					}
				);

				this.addNotification({
					id,
					type: 'partograph-alert',
					timestamp: new Date(),
					data: {
						status: payload.status,
						message: payload.message,
						patient_name: payload.patient_name,
						labour_id: payload.labour_id,
						event_time: payload?.chart?.event_time,
					},
					notificationApi: 'labour',
					notificationId: id,
				});
			}
		});
	}

	componentWillUnmount() {
		this.subscription.unsubscribe();
	}

	getCoords = elem => {
		return { top: 12, right: 100 };
	};

	openProfile = () => {
		const { profile } = this.props;
		const info = { staff: profile, type: 'staff' };
		this.props.toggleProfile(true, info);
	};

	getProfileImage = async () => {
		const image = await localStorage.getItem('STAFFIMAGE');
		return image;
	};

	toggleSettings = () => {
		const { hover_settings } = this.state;
		this.setState({ hover_settings: !hover_settings });
	};

	doToggleMode = () => {
		this.props.toggleMode();
	};

	setShowUnread = bool => {
		this.setState({ hover_unread: bool });
	};

	setShowNotifications = bool => {
		this.setState({ hover_notifications: bool });
	};

	doToggleMenu = () => {
		this.props.toggleMenu();
	};

	doToggleFullscreen = () => {
		this.props.toggleFullscreen();
	};

	onFocus = () => {
		const style = { display: 'block' };
		const coords = this.getCoords(this.refs.searchBox);
		this.setState({ style: { ...style, ...coords }, focus: true });
	};

	onExit = () => {
		const style = { display: 'none' };
		this.setState({ style, focus: false });
	};

	doLogout = async () => {
		const { profile } = this.props;

		if (profile.role.slug === 'doctor') {
			await request(`hr/staffs/unset-room/${profile.details.id}`, 'GET', true);
			storage.removeItem('ACTIVE:ROOM');
		}

		emitChat('logout', { userId: profile.details.id });

		storage.removeItem(USER_RECORD);
		storage.removeItem(SIDE_PANEL);
		storage.removeItem(TOKEN_COOKIE);
		storage.removeItem(CK_ENCOUNTER);
		storage.removeCookie(BROWSER_SESSION);

		this.props.signOut();

		disconnectSocket();
		disconnectChatSocket();
		this.props.setConnection(false);

		this.props.history.push('/');
	};

	doTriggerSound = () => {
		this.setState({ triggerSound: this.state.triggerSound + 1 });
	};

	handleTriggerSound = (from, message) => {
		this.doTriggerSound();

		// Add chat notification to container
		const notification = {
			id: `chat-${Date.now()}`,
			type: 'chat-message',
			timestamp: new Date(),
			data: {
				from,
				message: message.length > 20 ? message.substring(0, 20) + '...' : message,
			},
		};

		this.addNotification(notification);
	};

	doGoToChat = chat => {
		const chatId = chat.id;
		this.props.setChatId(chatId);
		this.props.setRoomId(null);
		this.props.history.push('/my-account/chat');
	};

	render() {
		const { role, location, profile, unread, unreadChats } = this.props;
		const paths = location.pathname.split('/');
		const title = paths.length > 1 ? paths[1] : '';
		const sub_title = paths.length > 2 ? paths[2] : '';
		const {
			hover_settings,
			hover_unread,
			hover_notifications,
			focus,
			style,
			count,
			profile_image,
			triggerSound,
			chatType,
			notifications,
			clearingNotifications,
		} = this.state;

		return (
			<div className="top-bar color-scheme-transparent">
				{title && title !== '' && (
					<div className="fancy-selector-w">
						<div className="fancy-selector-current">
							<div className="top-icon shadowless text-white pr-0" style={{ cursor: 'pointer' }} onClick={this.doToggleMenu}>
								<i className="os-icon os-icon-hamburger-menu-1" />
							</div>
							<div className="fs-img shadowless pr-0">
								<img alt="" src={topimg} />
							</div>
							<div className="fs-main-info">
								<div className="fs-name">
									<span>{`${upperCase(title.replace('-mgt', ''))} MANAGEMENT`}</span>
								</div>
								{sub_title && (
									<div className="fs-sub">
										<span>{startCase(sub_title)}</span>
									</div>
								)}
							</div>
						</div>
					</div>
				)}

				<div className="top-menu-controls" ref="searchBox">
					{hasViewSearchMenuPermission(profile.permissions) && (
						<>
							{focus && <SearchPatient style={style} onExit={this.onExit} focus={focus} />}
							<div className="element-search autosuggest-search-activator">
								<input placeholder="Find patient..." type="text" onFocus={this.onFocus} />
							</div>
							<VideoTutorialsPopover />
							{/* Notifications Dropdown */}
							<div
								className={`messages-notifications os-dropdown-trigger os-dropdown-position-left ${hover_notifications ? 'over' : ''}`}
								onMouseOver={() => this.setShowNotifications(true)}
								onMouseLeave={() => this.setShowNotifications(false)}
							>
								<i className="icon-feather-bell" />
								{count > 0 && <div className="new-messages-count">{count > 99 ? '99+' : count}</div>}
								<div className="os-dropdown light notification-list" style={{ width: '400px', maxHeight: '500px' }}>
									<div className="notification-header-actions" style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
										<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
											<h6 className="m-0">Notifications ({count})</h6>
											{count > 0 && (
												<button className="btn btn-sm btn-secondary" onClick={this.clearAllNotifications} disabled={clearingNotifications}>
													{clearingNotifications ? 'Clearing...' : 'Clear All'}
												</button>
											)}
										</div>
									</div>
									<div className="notification-container" style={{ maxHeight: '400px', overflowY: 'auto' }}>
										{notifications.length > 0 ? (
											notifications.map(notification => this.renderNotification(notification))
										) : (
											<div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No notifications</div>
										)}
									</div>
								</div>
							</div>
						</>
					)}

					{/* Chat Messages Dropdown */}
					<div
						className={`messages-notifications os-dropdown-trigger os-dropdown-position-left ${hover_unread ? 'over' : ''}`}
						onMouseOver={() => this.setShowUnread(true)}
						onMouseLeave={() => this.setShowUnread(false)}
					>
						<i className="os-icon os-icon-mail-14" />
						{unread > 0 && <div className="new-messages-count">{unread > 99 ? '99+' : unread}</div>}
						<SoundeComp playSound={triggerSound} chatType={chatType} />
						<div className="os-dropdown light message-list">
							<ul>
								{unreadChats.length > 0 ? (
									unreadChats?.map((chat, index) => {
										return (
											<li key={index + chat.first_name}>
												<a onClick={() => this.doGoToChat(chat)}>
													<div className="user-avatar-w">
														<img alt="" src={chat.profile_pic ?? parseAvatar(chat?.profile_pic)} />
													</div>
													<div className="message-content">
														<h6 className="message-from">{chat?.alias ?? chat.first_name + ' ' + chat.last_name}</h6>
														<h6 className="message-title">{chat.message[0].body}</h6>
													</div>
												</a>
											</li>
										);
									})
								) : (
									<li>
										<a href="#">
											<div className="message-content">
												<h6 className="message-from">No unread messages</h6>
											</div>
										</a>
									</li>
								)}
							</ul>
						</div>
					</div>

					<div
						className={`top-icon top-settings os-dropdown-trigger os-dropdown-position-left ${hover_settings ? 'over' : ''}`}
						onClick={this.toggleSettings}
					>
						<i className="os-icon os-icon-ui-46" />
						<div className="os-dropdown">
							<div className="icon-w">
								<i className="os-icon os-icon-ui-46" />
							</div>
							<ul>
								<li>
									<a onClick={this.doToggleMode}>
										<i className="os-icon os-icon-ui-49" />
										<span>Dark Mode ON/OFF</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="logged-user-w">
						<div className="logged-user-i">
							<div className="avatar-w">
								<img alt="" src={profile_image !== null ? profile_image : parseAvatar(profile?.details?.profile_pic)} />
							</div>
							<div className="logged-user-menu color-style-bright">
								<div className="logged-user-avatar-info">
									<div className="avatar-w">
										<img alt="" src={profile_image !== null ? profile_image : parseAvatar(profile?.details?.profile_pic)} />
									</div>
									<div className="logged-user-info-w">
										<div className="logged-user-name">{staffname(profile?.details)}</div>
										<div className="logged-user-role">{role !== 'patient' ? capitalize(role) : 'Doctor'}</div>
									</div>
								</div>
								<div className="bg-icon">
									<i className="os-icon os-icon-wallet-loaded" />
								</div>
								<ul>
									<li>
										<a onClick={this.openProfile}>
											<i className="os-icon os-icon-user-male-circle2" />
											<span>Profile Details</span>
										</a>
									</li>
									<li>
										<a onClick={this.doLogout} to="/logout" className="pointer">
											<i className="os-icon os-icon-signs-11" />
											<span>Logout</span>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				{/* Add custom styles */}
				<style jsx>{`
					.notification-item {
						padding: 15px;
						border-bottom: 1px solid #f0f0f0;
						background: #fff;
						margin-bottom: 2px;
					}
					.notification-item:hover {
						background: #f8f9fa;
					}
					.notification-item.lab-result {
						background: #1e62eb;
						color: white;
					}
					.notification-item.lab-result-approved {
						background: #8b5cf6;
						color: white;
					}
					.notification-item.chat-message {
						background: #00d9ff;
						color: white;
					}
					.notification-header {
						display: flex;
						justify-content: space-between;
						align-items: flex-start;
						margin-bottom: 8px;
					}
					.notification-container::-webkit-scrollbar {
						width: 6px;
					}
					.notification-container::-webkit-scrollbar-track {
						background: #f1f1f1;
					}
					.notification-container::-webkit-scrollbar-thumb {
						background: #c1c1c1;
						border-radius: 3px;
					}
					.notification-container::-webkit-scrollbar-thumb:hover {
						background: #a8a8a8;
					}
				`}</style>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		profile: state.user.profile,
		unread: state.chat.unread,
		unreadChats: state.chat.unreadChats,
		chatId: state.chat.chatId,
		roomId: state.chat.roomId,
		groupedChats: state.chat.groupedChats,
	};
};

export default withRouter(
	connect(mapStateToProps, {
		toggleProfile,
		toggleMode,
		toggleMenu,
		toggleFullscreen,
		signOut,
		setConnection,
		newChatMesage,
		setActiveUsers,
		setChatMessageRead,
		setChatId,
		setRoomId,
		setUnreadChats,
		setGroupedChats,
		setUnread,
		startBlock,
		stopBlock,
	})(TopBar)
);
